import React from 'react';
import { Helmet } from 'react-helmet';

export default class PageMeta extends React.Component {
    render() {
        return <Helmet>{this.props.title && <title>{this.props.title} | My Account</title>}</Helmet>;
    }
}
